export enum ContentType {
  MCQ = 'mcq',
  TRUE_FALSE = 'true_false',
  SELECT_MULTIPLE = 'select_multiple',
  EXPLANATION = 'explanation',
  COMMON_MISTAKES = 'common_mistakes',
  TIPS_TRICKS = 'tips_tricks',
  EXAMPLE_QA = 'example_qa',
  CODING_PROBLEM = 'coding_problem',
  CODE_SOLUTION = 'code_solution'
}

export const ContentTypeLabels: Record<ContentType, string> = {
  [ContentType.MCQ]: 'Multiple Choice Question',
  [ContentType.TRUE_FALSE]: 'True/False Question',
  [ContentType.SELECT_MULTIPLE]: 'Select Multiple',
  [ContentType.EXPLANATION]: 'Explanation',
  [ContentType.COMMON_MISTAKES]: 'Common Mistakes',
  [ContentType.TIPS_TRICKS]: 'Tips & Tricks',
  [ContentType.EXAMPLE_QA]: 'Example Q&A',
  [ContentType.CODING_PROBLEM]: 'Coding Problem',
  [ContentType.CODE_SOLUTION]: 'Code Solution'
};